import React from 'react';
import PageBanner from "@/components/pageBanner";
import {Link} from "react-router-dom";
import Paths from "../constants/Paths";

const WirtualnyAsystent = () => {
    return (
        <>
            <PageBanner title="AI Assistant" slug="ai-virtual-assistant" />
            <section className="dark-bg-with-gradients">
                <section className="generic-container py-14">
                    <h2 className={`font-bold text-lt-blue text-4xl`}>Virtual Assistant – Your Personal Expert in the
                        World
                        of
                        Investments</h2>
                    <p className={`font-bold pt-4 text-white`}>Locked Trade introduces the Virtual Assistant – a tool
                        designed for
                        traders at
                        every level of expertise.</p>
                    <p className={`pt-2 text-white`}>Our Virtual Assistant is a unique blend of advanced technology,
                        artificial
                        intelligence, and expert knowledge that helps you achieve better results in financial markets.
                        Whether you’re a beginner investor or an experienced trader, the Virtual Assistant provides you
                        with
                        the support and confidence to make informed investment decisions.</p>

                    <p className={`font-bold text-lt-blue pt-8 text-2xl`}>What Makes the Locked Trade Virtual Assistant
                        Stand
                        Out?</p>

                    <p className={`font-bold pt-4 text-white`}>1. Artificial Intelligence at Your Fingertips</p>
                    <p className={`pt-2 text-white`}>With AI support, our Virtual Assistant analyzes massive amounts of
                        market data
                        in
                        real-time. Its algorithms can:</p>
                    <ul className={`list-disc pl-8 pt-2 text-white`}>
                        <li>Predict potential market movements based on historical and current data.</li>
                        <li>Deliver personalized trading signals tailored to your trading style.</li>
                    </ul>

                    <p className={`font-bold pt-4 text-white`}>2. Intuitive and Easy to Use</p>
                    <p className={`pt-2 text-white`}>The tool is designed to be as accessible as possible. No
                        specialized technical
                        knowledge is required – just a few clicks to access advanced analyses.</p>

                    <p className={`font-bold pt-4 text-white`}>3. One-Click Analysis Generation</p>
                    <p className={`pt-2 text-white`}>The Virtual Assistant allows you to generate detailed market
                        analyses with a
                        single click.</p>

                    <p className={`font-bold pt-4 text-white`}>4. Accessibility from Anywhere</p>
                    <p className={`pt-2 text-white`}>Since the platform is fully online, you can use the Virtual
                        Assistant on any
                        device – computer, tablet, or smartphone. All you need is an internet connection.</p>

                    <p className={`font-bold text-lt-blue pt-8 text-2xl`}>What Benefits Does the Virtual Assistant
                        Offer?</p>

                    <p className={`font-bold pt-4 text-white`}>Optimization of Your Investment Strategy</p>
                    <p className={`pt-2 text-white`}>The Virtual Assistant doesn’t just deliver data; it helps you
                        interpret it.
                        This
                        allows you to make thoughtful decisions and avoid mistakes caused by a lack of information.</p>

                    <p className={`font-bold pt-4 text-white`}>Reduced Time for Analysis</p>
                    <p className={`pt-2 text-white`}>Say goodbye to hours spent manually searching for market data. The
                        Virtual
                        Assistant processes data automatically, delivering key insights in just seconds.</p>

                    <p className={`font-bold pt-4 text-white`}>Educational Support</p>
                    <p className={`pt-2 text-white`}>The Virtual Assistant is also a source of knowledge. With your
                        subscription,
                        you
                        gain access to educational materials that will help you better understand financial markets and
                        fully utilize the tool’s capabilities.</p>

                    <p className={`font-bold pt-4 text-white`}>Access to Live Trading Sessions and Webinars</p>
                    <p className={`pt-2 text-white`}>In higher subscription plans, you can participate in live trading
                        sessions and
                        webinars led by our experts. This is a unique opportunity to learn from real-world examples and
                        refine your skills.</p>

                    <p className={`font-bold text-lt-blue pt-8 text-2xl`}>Who Is the Virtual Assistant For?</p>

                    <p className={`pt-4 text-white`}>Our Virtual Assistant Is Designed For:</p>
                    <ul className={`list-disc pl-8 pt-2 text-white`}>
                        <li>Beginner Traders who need support in taking their first steps in the financial markets.</li>
                        <li>Intermediate Investors looking to enhance their skills and gain more confidence in making
                            decisions.
                        </li>
                        <li>Professional Traders seeking advanced analytical tools and time-saving solutions.</li>
                    </ul>
                </section>
            </section>
            <section>
                <section className="generic-container py-14">
                    <h2 className={`font-bold text-lt-blue pt-4 text-5xl`}>How to start?</h2>

                    <p className={`font-bold pt-4 text-lt-dark-blue`}>Optimization of Your Investment Strategy</p>

                    <ol className={`pl-8 pt-2 list-decimal text-lt-dark-blue`}>
                        <li><strong>Choose a subscription plan</strong> that best suits your needs.</li>
                        <li><strong>Register on our platform</strong> by providing the required details.</li>
                        <li><strong>Pay for your selected plan</strong> and wait for access to your chosen package to be
                            granted.
                        </li>
                        <li>In the meantime, explore <strong>short instructional videos</strong> to help you fully
                            utilize
                            the capabilities of the Virtual Assistant from the moment access is granted.
                        </li>
                    </ol>

                    <p className={`pt-4 text-lt-dark-blue`}>By following these steps, you’ll quickly and efficiently
                        embark on
                        your
                        investment journey with Locked Trade.</p>

                    <div className={`text-left mt-16`}>
                        <Link to={Paths.PRICING} className="big-button green-variant mx-auto">SUBSCRIBE</Link>
                    </div>
                </section>
            </section>
        </>
    );
};

export default WirtualnyAsystent;